import { Stack, Typography } from '@mui/material'
import TextField from '@mui/material/TextField'
import { ChangeEvent, useCallback, useMemo, useState } from 'react'
import { EOp, FilterModelText, Nullish } from 'types'

export function useAccessCodeFilter() {
  const [value, setValue] = useState<string>('')

  const accessCodeFilterValue: Nullish<FilterModelText> = useMemo(() => {
    if (value.length > 0) {
      return {
        type: 'text',
        op: EOp.contains,
        value,
      } as FilterModelText
    }

    return null
  }, [value])

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
  }, [])

  const AccessCodeFilter = useMemo(() => {
    return (
      <Stack direction="row" alignItems="center" className="gap-16">
        <Typography>Access Code</Typography>

        <TextField size="small" value={value} onChange={handleChange} />
      </Stack>
    )
  }, [handleChange, value])

  return { AccessCodeFilter, accessCodeFilterValue }
}
